import React from "react";
import { Link } from 'gatsby';
import * as b from "./bootstrap.module.css";
import Icon from "../components/icon.tsx";
import Ofin from "../../static/assets/ofin-header-dark.svg";
import PropsType from "prop-types";

const pages = [
  { to: "/banki/", text: 'Banki'},
  { to: "/dlugi/", text: 'Długi'},
  { to: "/oszustwa/", text: 'Oszustwa'},
  { to: "/bezpieczenstwo/", text: 'Bezpieczeństwo'},
  { to: "/platnosci/", text: 'Płatności'},
  { to: "/karta/", text: 'Karty płatnicze'},
  { to: "/karty-kredytowe/", text: 'Karty kredytowe'},
  { to: "/swiadczenia/", text: 'Świadczenia'},
  { to: "/rejestr/", text: 'Rejestry dłużników'}, 
  { to: "/kredyty-samochodowe/", text: 'Kredyt samochodowy'},
  { to: "/kredyt-preferencyjny/", text: 'Kredyt preferencyjny'},
  { to: "/kredyt-walutowy/", text: 'Kredyt walutowy'},
  { to: "/przedsiebiorstwo/ ", text: 'Przedsiębiorstwo'},
];

const pages2 = [
  { to: "/polityka-prywatnosci/", text: 'Polityka prywatności', rel: "nofollow" },
  { to: "/regulamin/", text: 'Regulamin', rel: "nofollow" },
]

const socials = [
  {
    href: "https://www.facebook.com/ofinpl/",
    icon: <Icon color="#ffffff" size={20} icon="Facebook" className="footer-icon"/>,
    text: "Facebook",
  },
];

const Footer = ({ homePage }) => {
  return (
    <footer className={["footer", !homePage && b.mt5].join(' ')}>
      <div className={b.container}>
        <div className={[b.dFlex, b.justifyContentCenter, b.justifyContentLgStart,b.pt3,b.ptLg5].join(" ")}>
          <Link to="/" aria-label='Logotyp serwisu Ofin.pl'>
            <Ofin />
          </Link>
        </div>

        <div className={[b.dLgFlex, b.flexWrap, "footer-list","footer-list-grid","main-links",b.mt4,'footer-border-bottom'].join(" ")}>
          {pages.map(({ to, text }, i) => (
            <div key={i} className={["font-size-18",b.mrLg3].join(' ')}>
              <Link to={to} activeClassName="active" className="footer-list-link">
                {text}
              </Link>
            </div>
          ))}
        </div>

        {homePage ? <>
          <span className={[b.dBlock, b.dLgNone, b.h5, b.mt4,'font-size-20'].join(" ")}>
            Ofin w mediach społecznościowych
          </span>

          <div className={[b.pt3,b.ptLg4].join(" ")}>
            {socials.map(({ href, icon, text }, i) => (
              <a key={i} href={href} target="_blank" rel="noopener noreferrer nofollow" className={["footer-list-link",b.mrLg3].join(' ')}>
                {icon}
                {text}
              </a>
            ))}
          </div>
        
          <div className={["footer-text", b.py4, b.ptLg3, b.pbLg4].join(" ")}>
            <div className={[b.row, b.justifyContentBetween].join(' ')}>
              <p className={b.colLgAuto}>
                2023 © ofin.pl. Wszystkie prawa zastrzeżone
              </p>

              <div className={b.dFlex}>
                {pages2.map(({ to, text, rel }, i) => (
                  <div key={i} className={["footer-links",b.ml3].join(' ')}>
                    <Link to={to} rel={rel}>
                      {text}
                    </Link>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </> : <div className={[b.pt4, b.pb3].join(' ')}>
          <p>
            2023 © ofin.pl. Wszystkie prawa zastrzeżone
          </p>
        </div>}
      </div>
    </footer>
  );
};

Footer.propsTypes = {
  homePage: PropsType.bool,
}

export default Footer;